import { buildStaffMenu } from "./staffMenu"
// Also available for IT-specific tweaks: overrideByKey, removeByKey, addItems from "./helpers"

/**
 * Information Technology role menu — cloned from the shared staff base.
 *
 * Currently mirrors the staff base exactly. To add IT-specific overrides
 * without affecting other roles, edit only this file. Example:
 *
 *   const menu = buildStaffMenu()
 *   return removeByKey(menu, "leave-request")
 */
export const buildItMenu = () => buildStaffMenu()
